import React from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import { Outlet, useSearchParams } from 'react-router-dom';

function Root() {
    // ?embed=1 is how the desktop Launcher opens a game in its webview: the site
    // chrome is dropped so only the game's own information is shown.
    const [searchParams] = useSearchParams();
    const isEmbedded = searchParams.get('embed') === '1';

    return (
        <>
            {!isEmbedded && <Navbar/>}
            <ScrollToTop/>
            <main>
                <Outlet/>
            </main>
            {!isEmbedded && <Footer/>}
        </>
    );
}

export default Root;